/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ElectricalSettingsKey, ElectricalSettingsState } from "./electrical-settings-reducer";

export const selectElectricalSettingsState = createFeatureSelector<ElectricalSettingsState>(ElectricalSettingsKey);

export const selectElectricalInformation = createSelector(selectElectricalSettingsState, (state) => state.electricalInformation);
export const selectElectricalShortcuts = createSelector(selectElectricalSettingsState, (state) => state.shortcuts);
export const selectInvalidShortcuts = createSelector(selectElectricalSettingsState, (state) => state.invalidShortcuts);
export const selectElectricalPreferences = createSelector(selectElectricalSettingsState, (state) => state.applyPreferences);
